export const isElectronApp = () => window.ELECTRON_APP === true
export const get = (key) => {
    if (!key) {
        return ""
    }

    return window[`ELECTRON_APP_${key}`] || ""
}
